import { PageIntro } from '@/components/PageIntro';
import { TabStrip } from '@/components/TabStrip';
import { useMe } from '@/lib/auth';
import { orgReportsApi } from '@/lib/reports';
import { ReportsPanel } from '@/features/reports/ReportsPanel';
import { useUsers } from './queries';

/** Overview | Scheduled & alerts tabs shared by the two Reports pages. */
export function UsageTabs() {
  const me = useMe();
  const unread = me.notifications?.unreadReports ?? 0;
  return <TabStrip ariaLabel="Report sections" items={[{ to: '/org/reports', label: 'Overview', end: true }, { to: unread > 0 ? '/org/reports/scheduled#your-reports' : '/org/reports/scheduled', label: 'Scheduled & alerts', badge: unread > 0 ? unread : undefined }]} />;
}

/** Organization → Reports → Scheduled & alerts: digests and event notices for the organization and its jobs. */
export function UsageReportsPage() {
  const me = useMe();
  const canManage = me.user.tenantRole === 'org_admin';
  const users = useUsers(canManage);
  const jobs = me.jobs.filter((j) => j.status !== 'archived').map((j) => ({ id: j.id, name: j.name }));
  const people = (users.data?.items ?? []).filter((u) => u.status === 'active').map((u) => ({ id: u.id, name: u.fullName, email: u.email }));
  return (
    <div className="space-y-5 sm:space-y-6">
      <PageIntro title="Reports" description="Digests on a schedule and alerts when something happens, for Super Users, job admins and anyone else you choose. Every recipient can mute them from their account." />
      <UsageTabs />
      <ReportsPanel api={orgReportsApi} queryKey={['reports', 'org']} scope="org" jobs={jobs} people={people} canManage={canManage} defaultTimezone={me.tenant.quietHours?.timezone ?? null} />
    </div>
  );
}
